'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';

import TextWrapperComponent from './text-wrapper/text-wrapper.component';
import {
    ArrowRightUp,
    GreenCalendar,
    LocationPin,
} from '../../../../public/Images';
import { sylndrDirections } from '@/constants';
import styles from './styles.module.scss';
import Image from 'next/image';

const ThankYouInspectionDetails = () => {
    const { t } = useTranslation();
    const directionComponent = () => {
        return (
            <a
                style={{ color: '#667085', display: 'flex', gap: '4px' }}
                href={sylndrDirections}
                target="_blank"
                rel="noreferrer"
            >
                <Typography variant={'body2Medium'} color="#667085">
                    {t('directions')}
                </Typography>
                <Image
                    src={ArrowRightUp.src}
                    width={ArrowRightUp.width}
                    height={ArrowRightUp.height}
                    alt="arrow up"
                />
            </a>
        );
    };
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant="body2Medium">
                {t('inspectionDetails')}
            </Typography>
            <section className={styles.car_details_section}>
                <TextWrapperComponent
                    textAbove={t('sylndrHubTitle')}
                    icon={LocationPin}
                    textBelow={t('mainShowroomAddress')}
                    optionalComponent={directionComponent()}
                />
                <TextWrapperComponent
                    textAbove={t('workingHoursTitle')}
                    icon={GreenCalendar}
                    textBelow={t('workingHoursValue')}
                />
            </section>
        </div>
    );
};

export default ThankYouInspectionDetails;
